import React from 'react';
import { useAuth } from '../context/AuthContext';
import { STATUS_CONFIG, QUALIFICATION_CONFIG, formatDateShort, formatNumber } from '../utils/constants';
import { Star, Trash2, MessageCircle } from 'lucide-react';
import api from '../utils/api';

export default function LeadTable({ leads, onSelect, onRefresh, selected, showDatasetCol }) {
  const { tenant } = useAuth();
  const customCols = tenant?.features?.custom_columns || [];

  const getExtraField = (lead, key) => {
    if (!lead.extra_data) return '—';
    try {
      const data = typeof lead.extra_data === 'string' ? JSON.parse(lead.extra_data) : lead.extra_data;
      return data[key] || '—';
    } catch { return '—'; }
  };

  return (
    <div className="table-container">
      <table>
        <thead><tr>
          <th style={{width:30}}></th>
          <th>Negocio</th>
          <th>Teléfono</th>
          <th>Ciudad</th>
          <th>Sector</th>
          {showDatasetCol && <th>Base</th>}
          <th>Fuente</th>
          <th>UTM Source</th>
          <th>Campaña</th>
          <th>Estado</th>
          <th>Calificación</th>
          {customCols.map(c => <th key={c.key}>{c.label}</th>)}
          <th>Ingreso</th>
          <th>Último contacto</th>
          <th style={{width:80}}></th>
        </tr></thead>
        <tbody>
          {leads.length === 0 ? (
            <tr><td colSpan={showDatasetCol ? 15 + customCols.length : 14 + customCols.length} style={{ textAlign:'center', padding:40, color:'var(--text-muted)' }}>No se encontraron leads</td></tr>
          ) : leads.map(lead => {
            const sc = STATUS_CONFIG[lead.status] || {};
            const qc = QUALIFICATION_CONFIG[lead.qualification] || {};
            return (
              <tr key={lead.id} onClick={() => onSelect && onSelect(lead)} style={{ cursor:'pointer', background: selected === lead.id ? 'var(--accent-glow)' : 'transparent' }}>
                <td onClick={e => { e.stopPropagation(); api.put('/leads/'+lead.id+'/favorite').then(onRefresh); }}>
                  <Star size={14} fill={lead.is_favorite ? '#eab308' : 'none'} color={lead.is_favorite ? '#eab308' : 'var(--text-muted)'} style={{cursor:'pointer'}}/>
                </td>
                <td style={{ fontWeight:600, maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.business_name || '—'}</td>
                <td style={{ fontSize:13 }}>{lead.phone || '—'}</td>
                <td style={{ fontSize:12, color:'var(--text-secondary)' }}>{lead.city || '—'}</td>
                <td style={{ fontSize:12, color:'var(--text-secondary)' }}>{lead.category || '—'}</td>
                {showDatasetCol && <td style={{ fontSize:12, color:'var(--text-muted)' }}>{lead.dataset_name || '—'}</td>}
                <td><span className="badge" style={{ fontSize:10, background:'rgba(46,125,226,0.12)', color:'var(--accent)' }}>{lead.source || '—'}</span></td>
                <td style={{ fontSize:11, color:'var(--text-muted)' }}>{lead.utm_source || '—'}</td>
                <td style={{ fontSize:11, color:'var(--text-muted)', maxWidth:120, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{lead.utm_campaign || '—'}</td>
                <td><span className="badge" style={{ background: sc.bg || 'rgba(100,116,139,0.15)', color: sc.color || '#64748b', fontSize:11 }}>{sc.label || lead.status}</span></td>
                <td><span className="badge" style={{ background: qc.bg || 'rgba(100,116,139,0.15)', color: qc.color || '#64748b', fontSize:11 }}>{qc.label || lead.qualification}</span></td>
                {customCols.map(c => <td key={c.key} style={{ fontSize:12, color:'var(--text-secondary)' }}>{getExtraField(lead, c.key)}</td>)}
                <td style={{ fontSize:12, color:'var(--text-muted)' }}>{formatDateShort(lead.created_at)}</td>
                <td><input type="date" value={lead.last_contacted_at ? lead.last_contacted_at.split('T')[0] : ''} onChange={async e => { try { await api.put('/leads/'+lead.id+'/last-contact', { date: e.target.value }); onRefresh(); } catch {} }} onClick={e => e.stopPropagation()} style={{ background:'transparent', border:'1px solid var(--border)', borderRadius:6, padding:'2px 6px', fontSize:11, color:'var(--text-secondary)', width:120, cursor:'pointer' }} /></td>
                <td>
                  <div style={{ display:'flex', gap:4 }}>
                    <button className="btn btn-ghost btn-sm" onClick={e => { e.stopPropagation(); if(window.confirm('¿Eliminar este lead?')) api.delete('/leads/'+lead.id).then(onRefresh); }} style={{ color:'var(--danger)', padding:4 }}><Trash2 size={14}/></button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
